const SELECTORS = {
  card: ".js-post-card-sns-user-mute",
  info: ".js-post-card-sns-user-mute-info",
  caption: ".js-post-card-sns-user-mute-caption",
  content: ".js-post-card-sns-user-mute-content",
  unmuteCardButton: ".js-post-card-sns-user-mute-unmute-card-btn",
  muteCardButton: ".js-post-card-sns-user-mute-mute-card-btn",
};

class PostCardSnsUserMuteComponent {
  constructor(rootElement = document) {
    this._setEvent(rootElement);
  }

  _setEvent(rootElement) {
    this._setUnmuteCardEvent(rootElement);
    this._setMuteCardEvent(rootElement);
  }

  _setUnmuteCardEvent(rootElement) {
    rootElement.querySelectorAll(SELECTORS.card).forEach((card) => {
      const unmuteCardButton = card.querySelector(SELECTORS.unmuteCardButton);
      unmuteCardButton.addEventListener("click", (e) => {
        e.preventDefault();
        _toggleCard(card, false)
      });
    });
  }

  // 「投稿を非表示」ボタンは …メニュー（ActionDropdown 島）の中にあり、島のマウント（非同期）後に DOM へ現れる。
  // 構築時点の querySelectorAll では捕まらないため、rootElement への委譲で拾う（同じ root には 1 回だけ張る）。
  _setMuteCardEvent(rootElement) {
    if (_muteCardEventBoundRoots.has(rootElement)) return;
    _muteCardEventBoundRoots.add(rootElement);

    rootElement.addEventListener("click", (e) => {
      if (!(e.target instanceof Element)) return;
      const muteCardButton = e.target.closest(SELECTORS.muteCardButton);
      if (!muteCardButton) return;
      e.preventDefault();
      _toggleCard(muteCardButton.closest(SELECTORS.card), true);
    });
  }
}

// _setMuteCardEvent の委譲リスナーを張った root。addToggleMuteEvent が同じ root で再び呼ばれても二重発火しない。
const _muteCardEventBoundRoots = new WeakSet();

const _toggleCard = (card, isMute) => {
  const [info, caption, content] = [
    SELECTORS.info,
    SELECTORS.caption,
    SELECTORS.content,
  ].map((selector) => card.querySelector(selector));


  const isTwoColumnsMobile = _isTwoColumnsMobile(card);
  if (isMute) {
    isTwoColumnsMobile ? info.classList.remove("hidden") : info.classList.add("hidden", "md:block");
    caption.classList.remove("hidden");
    content.classList.add("hidden");
  } else {
    info.classList.add("hidden");
    info.classList.remove("md:block");
    caption.classList.add("hidden");
    content.classList.remove("hidden");
  }
};

const _toggleMuteCardButton = (card, isMute) => {
  const muteCardButton = card.querySelector(SELECTORS.muteCardButton);

  if (isMute) {
    muteCardButton.classList.remove("hidden");
  } else {
    muteCardButton.classList.add("hidden");
  }
};

const _isTwoColumnsMobile = (card) => {
  return card.dataset.isTwoColumnsMobile === "true";
};

const _getCardsByUserId = (userId, rootElement = document) => {
  return rootElement.querySelectorAll(`${SELECTORS.card}[data-user-id="${userId}"]`);
}

const muteByUserId = (userId, rootElement = document) => {
  _getCardsByUserId(userId, rootElement).forEach((card) => {
    _toggleCard(card, true)
    _toggleMuteCardButton(card, true);
  });
};

const unmuteByUserId = (userId, rootElement = document) => {
  _getCardsByUserId(userId, rootElement).forEach((card) => {
    _toggleCard(card, false)
    _toggleMuteCardButton(card, false);
  });
}

export default PostCardSnsUserMuteComponent;
export { muteByUserId, unmuteByUserId };
